import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all externalServiceses
export const getExternalServices = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/external-services`);
    return response.data;
  } catch (error) {
    console.error("Error fetching external-services:", error.response?.data || error);
    throw error;
  }
};

export const checkExternalServiceName = async (name, excludeId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/external-services/check-name`, {      params: { name, excludeId },
    });
    return response.data.exists;
  } catch (error) {
    console.error("Error checking external-services name:", error.response?.data || error);
    throw error;
  }
};

// GET a single externalServices
export const getExternalServicesById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/external-services/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching external-services:", error.response?.data || error);
    throw error;
  }
};

export const createExternalServices = async (externalServicesData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/external-services`, externalServicesData);
    return response.data;
  } catch (error) {
    console.error("Error creating external-services:", error.response?.data || error);
    throw error;
  }
};

export const updateExternalServices = async (id, externalServicesData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/external-services/${id}`, externalServicesData);
    return response.data;
  } catch (error) {
    console.error("Error updating external-services:", error.response?.data || error);
    throw error;
  }
};

export const deleteExternalServices = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/external-services/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting external-services:", error.response?.data || error);
    throw error;
  }
};
